import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "sv-page" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("header", { class: "sv-page-header" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("span", { class: "sv-page-header__eyebrow" }, "Histórico pesquisável"),
    /*#__PURE__*/_createElementVNode("h1", null, "Gravações"),
    /*#__PURE__*/_createElementVNode("p", null, "Encontre, analise e reproduza as conversas armazenadas pela operação.")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CardsRecordings = _resolveComponent("CardsRecordings")!
  const _component_RecordingsTable = _resolveComponent("RecordingsTable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_CardsRecordings),
    _createVNode(_component_RecordingsTable)
  ]))
}